import React from 'react';
import {observer, inject} from 'mobx-react';
import {injectIntl} from 'react-intl';
import Comment from './Comment';
import CommentForm from './CommentForm';


@injectIntl  @inject("rootStore", "feedbackCommentsStore") @observer
export default class FeedbackChainCommentsArea extends React.Component {

    render() {
        let {intl, feedbackChain} = this.props;
        const newFeedbackComment = this.props.feedbackCommentsStore.buildFeedbackComment(feedbackChain);

        let comments = (feedbackChain.comments.length != 0) ?
            feedbackChain.filteredComments.map( comment => <Comment key={comment.id} comment={comment} /> ) : null;

        return(
            <div>
                { feedbackChain.canComment() && <CommentForm comment={newFeedbackComment} /> }
                { comments != null &&
                    <div>
                        <hr/>
                        <h4 className={"bold"}>{intl.formatMessage({id: 'comments_title'})}</h4>
                        <div className={'comments-list'}>
                            {comments}
                        </div>
                    </div>
                }
            </div>
        );
    }

}